// Enums
import { MainNavigationEnum } from '@shared/enum/main-navigation-url.enum';

/**
 * A single navigable item in the side-nav rail.
 */
export interface NavItem {
  /** Visible label. */
  label: string;
  /** Absolute route path (e.g. `/users`). */
  route: string;
  /** App-permission that gates visibility (ngx-permissions name). */
  permission: string;
}

/**
 * A labelled, collapsible group of nav items.
 */
export interface NavGroup {
  /** Group heading. */
  label: string;
  /** Items in the group. */
  items: NavItem[];
}

/**
 * The labelled side-nav groups (text-only, no icons — matching the prototype rail).
 */
export const NAV_GROUPS: readonly NavGroup[] = [
  {
    label: 'Access & Identity',
    items: [
      { label: 'Users', route: `/${MainNavigationEnum.USERS}`, permission: 'user-read' },
      { label: 'Bulk Role Assignment', route: `/${MainNavigationEnum.BULK_ROLE_ASSIGNMENT}`, permission: 'user-write' },
      { label: 'API Tokens', route: `/${MainNavigationEnum.TOKENS}`, permission: 'token-read' },
      { label: 'Token Expirations', route: `/${MainNavigationEnum.TOKENS}/expirations`, permission: 'token-read' },
    ],
  },
  {
    label: 'Clients',
    items: [{ label: 'Clients', route: `/${MainNavigationEnum.CLIENTS}`, permission: 'client-read' }],
  },
  {
    label: 'Activity',
    items: [{ label: 'Historical Pulls', route: `/${MainNavigationEnum.HISTORICAL_PULL}`, permission: 'historical-pull-read' }],
  },
  {
    // One entry for the whole area: Conversations, Chat Feedback and Unanswered Questions are
    // now tabs of a single page, not three destinations. `route` is the bare area path, which
    // `chat-admin.routes.ts` redirects to the first tab; the rail's longest-prefix matching
    // (see `SideNavComponent.activeRoute`) keeps the entry highlighted on every tab and on the
    // detail pages beneath them.
    label: 'Ignite Assistant',
    items: [{ label: 'Ignite Assistant', route: `/${MainNavigationEnum.CHAT_ADMIN}`, permission: 'chat-admin-read' }],
  },
];
